import { api } from "./api";

export const adminUsersService = {
  // Full CRUD (Phase A3)
  list: (params = {}) => api.get("/admin/users", { params }).then((r) => r.data),
  get: (id) => api.get(`/admin/users/${id}`).then((r) => r.data),
  create: (payload) => api.post("/admin/users", payload).then((r) => r.data),
  update: (id, payload) => api.patch(`/admin/users/${id}`, payload).then((r) => r.data),
  remove: (id) => api.delete(`/admin/users/${id}`).then((r) => r.status),
  resetPassword: (id, new_password) =>
    api.post(`/admin/users/${id}/reset-password`, { new_password }).then((r) => r.data),

  // Lightweight picker payload (used by orders/wizard on-behalf-of).
  summary: () => api.get("/admin/users/summary").then((r) => r.data),
};

export const adminOrdersService = {
  listAll: (params = {}) =>
    api.get("/admin/orders/all", { params }).then((r) => r.data),
};
